<google-map [width]="width" [height]="height" [center]="center" [options]="options" (mapClick)="gmapClick($event)" #GoogleMap>
  @for (markerOptions of markers; track markerOptions) {
    <map-marker #marker="mapMarker" [options]="markerOptions" (mapDblclick)="gmarkerDblClick($event,marker,markerOptions)" (mapClick)="gmarkerClick($event,marker,markerOptions)"></map-marker>
  }
  <map-info-window [innerHTML]="(infoContent) | safeHtml" routeTransformer></map-info-window>
</google-map>